import Axios from "axios";
import {initCompanyForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initCompaniesCreate(){

    const companyForm = initCompanyForm(document.querySelector('.company-form'));

    document.querySelector('.create-new-company-button').onclick = createNewCompany;

    function createNewCompany(){
        const companyData = companyForm.inputs();

		companyForm.clearFeedbacks();

        loading();

        Axios.post(companyForm.postUrl(),companyData)
            .then(response => {
                handleAjaxSuccess(response,() => {
                    loading()
                    window.location = companyForm.successUrl()
                })
            })
            .catch(handleAjaxError)
            .finally(stopLoading)
    }
}

export {initCompaniesCreate}
